import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { LoginComponent } from "./login/login.component"
import { AuthGuardService as AuthGuard } from "./auth/auth-guard.service"
import { DialogComponent } from "./shared/dialog/dialog.component"
import { PrintPageComponent } from "./shared/print-page/print-page.component"
import { PrintPurchaseComponent } from "./shared/print-purchase/print-purchase.component"
import { DeleteAccComponent } from "./shared/delete-acc/delete-acc.component"
import { ChangeLogComponent } from "./change-log/change-log.component"
const routes: Routes = [
    {
        path: "dashboard",
        loadChildren: () =>
            import("./dashboard/dashboard.module").then(
                (m) => m.DashboardModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "account",
        loadChildren: () =>
            import("./account/account.module").then((m) => m.AccountModule),
        canActivate: [AuthGuard],
    },
    {
        path: "food-mgmt",
        loadChildren: () =>
            import("./food-mgmt/food-mgmt.module").then(
                (m) => m.FoodMgmtModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "customer-mgmt",
        loadChildren: () =>
            import("./customer-mgmt/customer-mgmt.module").then(
                (m) => m.CustomerMgmtModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "user-mgmt",
        loadChildren: () =>
            import("./user-mgmt/user-mgmt.module").then(
                (m) => m.UserMgmtModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "promotion",
        loadChildren: () =>
            import("./promotion/promotion.module").then(
                (m) => m.PromotionModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "mobile-mgmt",
        loadChildren: () =>
            import("./mobile-mgmt/mobile-mgmt.module").then(
                (m) => m.MobileMgmtModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "feedback",
        loadChildren: () =>
            import("./feedback/feedback.module").then((m) => m.FeedbackModule),
        canActivate: [AuthGuard],
    },
    {
        path: "omise",
        loadChildren: () =>
            import("./omise/omise.module").then((m) => m.OmiseModule),
        canActivate: [AuthGuard],
    },
    {
        path: "report",
        loadChildren: () =>
            import("./report/report.module").then((m) => m.ReportModule),
        canActivate: [AuthGuard],
    },
    {
        path: "stock",
        loadChildren: () =>
            import("./stock/stock.module").then((m) => m.StockModule),
        canActivate: [AuthGuard],
    },
    {
        path: "config",
        loadChildren: () =>
            import("./config/config.module").then((m) => m.ConfigModule),
        canActivate: [AuthGuard],
    },
    {
        path: "invoice",
        loadChildren: () =>
            import("./invoice/invoice.module").then((m) => m.InvoiceModule),
        canActivate: [AuthGuard],
    },
    {
        path: "adjust-order",
        loadChildren: () =>
            import("./adjust-order/adjust-order.module").then(
                (m) => m.AdjustOrderModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "income-expense",
        loadChildren: () =>
            import("./income-expense/income-expense.module").then(
                (m) => m.IncomeExpenseModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: "partner",
        loadChildren: () =>
            import("./partner/partner.module").then((m) => m.PartnerModule),
        canActivate: [AuthGuard],
    },
    {
        path: "print",
        component: PrintPageComponent,
    },
    {
        path: "print-purchase",
        component: PrintPurchaseComponent,
    },
    {
        path: "delete-account",
        component: DeleteAccComponent,
    },
    {
        path: "change-log",
        component: ChangeLogComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
    },
    { path: "login", component: LoginComponent },
    {
        path: "**",
        redirectTo: "login",
        pathMatch: "full",
    },
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
